module.exports = __webpack_public_path__ + "static/media/Thermocycler steps.493d96fb.svg";